import React, { useEffect, useState } from "react";
import Header from "../../components/header/Header";
import { useParams } from "react-router-dom";
import "../../assets/styles/style.css";
import Card from "../../components/card/Card";
import Footer from "../../components/footer/Footer";
import pageBanner from "../../assets/images/detail-page-banner.jpg";
import avatarImage from "../../assets/images/nick-user2.png";
import Loader from "../../components/loader/Loader";
import APIService from "../../utils/APIService";
import { extractHeadings, updateHeadingsInHtml } from "../../utils/Helper";
import TableOfContents from "../../components/sidebar/TableOfContents";
import user2 from "../../assets/images/nick-user2.png";
import post from "../../assets/images/post1.webp";
import post2 from "../../assets/images/post2.webp";

const BlogDetails = () => {
  const { slug } = useParams();
  const [blogDetails, setBlogDetails] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);
  const [headings, setHeadings] = useState([]);

  useEffect(() => {
    setLoading(true);
    window.scrollTo(0, 0);
    fetchBlogDetails(slug);
  }, [slug]);

  const fetchBlogDetails = async (slug) => {
    try {
      const blogData = await APIService.get(`/blogs/detail/${slug}`);
      console.log(blogData);
      setLoading(false);
      setBlogDetails(blogData);
      const updatedDescription = updateHeadingsInHtml(
        blogData.blog.description
      );
      setHeadings(extractHeadings(blogData.blog.description)); // Set headings
      setBlogDetails({
        ...blogData,
        blog: {
          ...blogData.blog,
          description: updatedDescription,
        },
      });
    } catch (error) {
      setError(true);
      console.error("Error fetching blog details:", error);
    }
  };

  const formattedDate = new Date(
    blogDetails?.blog.createdDate
  ).toLocaleDateString("en-US", {
    year: "numeric",
    month: "long",
    day: "numeric",
  });

  if (loading) {
    return <Loader />;
  }

  if (error) {
    return <div>Error fetching blog details</div>;
  }

  const formatDate = (isoDate) => {
    const date = new Date(isoDate);
    const options = { year: 'numeric', month: 'long', day: 'numeric' };
    const formattedDate = date.toLocaleDateString('en-US', options);
    return formattedDate;
  }

  return (
    <div className="wrapper">
      <Header isBackEnable={true} />
      <main className="blog-details-page main-curve-top">
      <div className="happy-left">&nbsp;</div>
      <div className="happy-right">&nbsp;</div>
        <div className="blog-post-detail">
          <div className="container-blog container">
            <div className="row">
              <div className="col-lg-12">
                <div className="blog-banner-content">
                  <a href="" className="technology-btn">{blogDetails.blog.category?.name}</a>
                  <h2>{blogDetails.blog.title}</h2>
                  <div className="user-content">
                    <div className="userName">
                      <img src={blogDetails.blog.authorImage || avatarImage}
                        alt={blogDetails.blog.authorName} className="popularPost" />
                      <p>{blogDetails.blog.authorName}</p>
                    </div>
                    <p>{formatDate(blogDetails.blog.createdDate)}</p>
                  </div>
                </div>
              </div>
              <div className="col-lg-12">
                <div className="img-block">
                  <img src={blogDetails.blog.image}
                    alt={blogDetails.blog.title} className="postImg" />
                </div>
              </div>
            </div>
          </div>
        </div>
        <section className="post-sec">
          <div className="container">
            <div className="row">
              <div className="col-lg-12">
                <div className="post-content">
                  <div
                    dangerouslySetInnerHTML={{
                      __html: blogDetails?.blog.description,
                    }}
                  ></div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
};

export default BlogDetails;
